
export const LocalStorageKeys = Object.freeze({
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  CSV_CONFIG: 'csvConfig'
})
